import React from 'react'
import { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon'
import Icon from '@ant-design/icons'

interface NotificationsSvgProps {
  count?: number
}

export const NotificationsSvg = ({ count }: NotificationsSvgProps) => {
  return (
    <svg id="b" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 28.352 42.007">
      <g id="c" data-name="Layer 1">
        <path d="M27.7,31.341c-1.766-2.139-2.737-4.878-2.737-7.713,0-.92.104-1.835.309-2.719.008-.033.015-.067.02-.102.836-3.292.08-6.762-2.086-9.545-1.1-1.414-2.46-2.522-3.974-3.274v-2.828c0-2.845-2.315-5.16-5.16-5.16s-5.16,2.315-5.16,5.16v3.045c-1.294.698-2.471,1.642-3.445,2.833-2.152,2.632-3.021,5.979-2.406,9.22.001.115.018.229.049.343,1,3.578.07,7.682-2.428,10.708-.739.895-.889,2.1-.392,3.145.494,1.038,1.513,1.68,2.655,1.68h.022l5.537-.004c.206,3.275,2.928,5.878,6.254,5.878s6.053-2.608,6.255-5.887l4.38-.003c1.159-.008,2.188-.67,2.683-1.729.477-1.021.334-2.189-.374-3.047ZM11.572,5.16c0-1.378,1.122-2.5,2.5-2.5s2.5,1.122,2.5,2.5v1.924c-.754-.153-1.524-.236-2.308-.222-.917-.009-1.818.105-2.692.316v-2.018ZM14.757,39.347c-1.857,0-3.392-1.408-3.591-3.214h7.183c-.2,1.806-1.734,3.214-3.592,3.214ZM25.663,33.262c-.021.045-.104.194-.281.195l-22.425.016c-.137,0-.213-.054-.264-.162-.052-.109-.038-.213.041-.309,2.984-3.616,4.125-8.519,3.008-12.86-.005-.06-.013-.12-.026-.18-.544-2.528.116-5.167,1.812-7.241,1.688-2.065,4.156-3.23,6.74-3.2,2.65-.032,5.14,1.192,6.839,3.375,1.68,2.16,2.255,4.845,1.578,7.367-.018.063-.029.126-.037.19-.228,1.035-.344,2.103-.344,3.174,0,3.452,1.188,6.792,3.345,9.406.023.028.078.095.016.228Z" fill="#858584"/>
      </g>
      {count || 0 >= 1
        ? [
          <circle
            key="alert"
            data-testid="notifications-icon-alert"
            cx={22.5}
            cy={4.7}
            r={4.7}
            fill="#ea425f"
          />,
          <text
            key="count"
            data-testid="notifications-icon-count"
            x={22.5}
            y={5}
            stroke="white"
            color="white"
            fill="white"
            fontSize="0.3em"
            textAnchor="middle"
            alignmentBaseline="middle"
            fontWeight={100}
          >
            {count}
          </text>,
        ]
        : null}
    </svg>
  )
}

export type NotificationIconsProps = AntdIconProps & NotificationsSvgProps

export const NotificationsIcon = (props: NotificationIconsProps) => (
  <Icon
    component={() => <NotificationsSvg count={props.count}/>}
    {...(props as any)}
  />
)
